<template>
  <div>
    <FormStepInputs
      :step="{
        stepName: name,
        formInputs: content,
      }"
    >
      <template #yourProducts>
        <div data-test-id="product_list_component">
          <ProductCardList
            :fields="yourProducts"
            :hideAssistance="true"
            :hideBank="true"
            :portfolio="accountStore.identityDetails?.portfolio"
          />
        </div>
      </template>
    </FormStepInputs>
  </div>
</template>
<script setup lang="ts">
import { onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { ISitecoreFormGenericInput } from '@/interfaces';
import FormStepInputs from '@/components/FormStepInputs/FormStepInputs.vue';
import ProductCardList from '@/components/ProductCardList/ProductCardList.vue';
import { useAccountStore } from '@/store';
import { PageAnalyticsBuilder } from '@/utils/page-analytics-builder';

const props = defineProps<{
  content: ISitecoreFormGenericInput[];
  id: string;
  name: string;
}>();

const accountStore = useAccountStore();
const yourProducts = props.content.find((item) => item.formInputId.value == 'yourProducts');
const dictionary = useI18n().getLocaleMessage('en') as Record<string, string>;

onMounted(() => {
  pushAnalytics();
});

const pushAnalytics = async () => {
  const pageAnalytics = new PageAnalyticsBuilder();
  pageAnalytics.populateProducts(dictionary);
  pageAnalytics.pushAnalytics();
};
</script>
